import redGold from "../../assets/images/arts/redGold.png";

const BountyToken = () => {
    return (
        <div className="bg-strip py-5" id="utility">
            <div className="container">
                <div className="row flex-lg-row-reverse">
                    <div className="col-lg-5 text-center">
                        <img className="gold-img img-fluid animat-img" src={redGold} alt="G Fox" />
                    </div>
                    <div
                     data-aos="fade-right" data-aos-offset="700"
                     className="col-lg-7 col-12 text-justify px-lg-5 px-3 pt-3  d-flex flex-column justify-content-center align-items-start">
                    <h2 className="sec-heading px-2 text-justify text-white mb-4">Bounty Token</h2>
                        <p className="text-white px-2">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi, facere. Neque non natus voluptate doloremque quidem. Veritatis minima, provident beatae accusantium illo optio veniam, vel repellat quos iusto tenetur, laborum odio excepturi saepe architecto distinctio esse exercitationem unde voluptatum placeat numquam. Ullam molestias ducimus maiores quae, magnam voluptatem asperiores a!
                            Lorem ipsum dolor sit  
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BountyToken
